module.exports = __webpack_public_path__ + "img/iconleft_close.cad8bd99.svg";